import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface FormActionsProps {
  isSubmitting: boolean;
  mode: 'create' | 'edit';
}

export function FormActions({ isSubmitting, mode }: FormActionsProps) {
  const navigate = useNavigate();
  
  return (
    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 4 }}>
      <Button
        variant="outlined"
        onClick={() => navigate('/pets')}
        disabled={isSubmitting}
      >
        Cancelar
      </Button>
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Salvando...' : mode === 'create' ? 'Criar Pet' : 'Atualizar Pet'}
      </Button>
    </Box>
  );
} 